export default function areAllCompetitiveBidOffers(bids = []){
  return !bids.find(b => !(b.isCompetitiveOffer))
}

export function isAnyCompetitiveBidOffer(bids = []){
  return !!bids.find(b => b.isCompetitiveOffer || b.state.status === 'COMPETITIVE_REFUSED')
}